import { useState, useEffect } from "react";
import { fetchArticles } from "../Services/ArticleService";
import { getAuthData } from "../Auth/getAuthData";
import { companyUnitDetails } from "../Auth/GetUnitCompany";
import authHeader from "../Auth/authHeader";
import { getAllMyCompanyData } from "../GetData/GetCompanyData";

export function useArticles(searchTerm) {
  const [listArticles, setListArticles] = useState([]);
  const [page, setPage] = useState(1);
  const headers = authHeader();
  const authData = getAuthData();
  

  // 🔑 NDAJE loading-un
  const [loadingInitial, setLoadingInitial] = useState(false); // për hapje / search
  const [loadingMore, setLoadingMore] = useState(false); // për scroll
  const [salesTypeID, setSalesTypeID] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // ============================
  // LOAD FILLESTAR + SEARCH
  // ============================
  useEffect(() => {
    setListArticles([]);
    setPage(1);
    setHasMore(true);

    const controller = new AbortController();

    const loadInitial = async () => {
      // const companyUnitID = getAuthData?.companyUnitId ?? 0;
      const companyUnitID = Number(authData?.companyUnitId || 0);
      const companyData = await getAllMyCompanyData();

      let finalSalesType = 1; // Vlera default

      // 2. Thirr detajet e njësisë vetëm nëse kemi një UnitID konkret (> 0)
      if (companyUnitID > 0) {
        // TANI LEJOHET AWAIT sepse jemi brenda një funksioni async
        const response = await companyUnitDetails(headers, companyUnitID);
        if (response && response.length > 0) {
          finalSalesType = response[0].SalesTypeID ?? 1;
        }
      }
      else if(companyUnitID==0){
        // console.log(companyData[0].SalesTypeID);
        finalSalesType=companyData[0].SalesTypeID ?? 1
      }

      try {
        setLoadingInitial(true); // ✅ vetëm këtu

        const data = await fetchArticles({
          search: searchTerm || "",
          page: 1,
          pageSize: 50,
          salesTypeId: finalSalesType,
          signal: controller.signal,
        });

        setListArticles(data);
        setHasMore(data.length === 50);
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
      } finally {
        setLoadingInitial(false);
      }
    };

    loadInitial();
    return () => controller.abort();
  }, [searchTerm]);

  // ============================
  // INFINITE SCROLL (PA reload)
  // ============================
  useEffect(() => {
    if (!hasMore || loadingMore || page === 1) return;

    const controller = new AbortController();

    const loadMore = async () => {
      try {
        setLoadingMore(true); // ⚠️ MOS prek Autocomplete
        const data = await fetchArticles({
          search: searchTerm || "",
          page,
          pageSize: 50,
          signal: controller.signal,
        });

        setListArticles((prev) => [...prev, ...data]);
        if (data.length < 50) setHasMore(false);
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
      } finally {
        setLoadingMore(false);
      }
    };

    loadMore();
    return () => controller.abort();
  }, [page]); // ✅ vetëm page

  return {
    listArticles,
    loadingInitial,
    loadingMore,
    setPage,
    hasMore,
  };
}
